import { render, staticRenderFns } from "./ApprovalProgress.vue?vue&type=template&id=2771f197&"
import script from "./ApprovalProgress.vue?vue&type=script&lang=js&"
export * from "./ApprovalProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports